export default function OptionsIcon() {
  // Icon from https://svgbox.net/iconset/hero-solid
  // Whitespace removal from https://svgcrop.com/
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="2 8 16 4"
    >
      {' '}
      <path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zm6 0a2 2 0 11-4 0 2 2 0 014 0zm4 2a2 2 0 100-4 2 2 0 000 4z"></path>{' '}
    </svg>
  );
}
